module.exports = __webpack_public_path__ + "img/emoji_cahan.a5a67ea7.png";